"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLimits = fetchLimits;

var _immutable = _interopRequireDefault(require("immutable"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URI = 'filemanager/api/v3/limits';

function fetchLimits() {
  var httpClient = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _apiClient.default;
  return httpClient.get(BASE_URI).then(_immutable.default.fromJS);
}